import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiOutlineWhatsApp, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Muhammad Faran Akbar</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} MFA</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://wa.me/923289858409"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
              >
                <AiOutlineWhatsApp />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/m-faran-akbar-495680347"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/mfaranakbar"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
